import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MediaRecorderState {
  previewStream: MediaStream | null;
  status: 'idle' | 'recording' | 'stopped';
  recordedBlob: Blob | null;
  isRecording: boolean;
}

const initialState: MediaRecorderState = {
  previewStream: null,
  status: 'idle',
  recordedBlob: null,
  isRecording: false,
};

const mediaRecorderSlice = createSlice({
  name: 'mediaRecorder',
  initialState,
  reducers: {
    setPreviewStream(state, action: PayloadAction<MediaStream | null>) {
      state.previewStream = action.payload;
    },
    setStatus(state, action: PayloadAction<'idle' | 'recording' | 'stopped'>) {
      state.status = action.payload;
    },
    setRecordedBlob(state, action: PayloadAction<Blob | null>) {
      state.recordedBlob = action.payload;
    },
    setIsRecording(state, action: PayloadAction<boolean>) {
      state.isRecording = action.payload;
    },
    
  },
});

export const { setPreviewStream, setStatus, setRecordedBlob, setIsRecording } = mediaRecorderSlice.actions;

export default mediaRecorderSlice.reducer;
